import { varsFromServer } from './client_side_injection_vars';

// Valid track event names
// analytics.track(EVENT_NAME)
export const EventNameTypes = {
  form: 'Form Submission',
  interaction: 'Interaction',
  page: 'Loaded a Page',
  bucket: 'Bucket',
  timing: 'Timing',
  signupActivity: 'Signup Activity',
  chatActivity: 'Chat Activity',
  availabilityPayload: 'Availability Payload',
  checkout3ds: '3DS Checkout'
};

// Google Tag Manager window.dataLayer Event names
export const DataLayerEventTypes = {
  CHECKOUT_PAYMENT_LEGACY: 'commons signup',
  CHECKOUT_PAYMENT: 'checkout payment complete',
  LEAD_SUBMISSION: 'lead submitted'
};

export function makeSegmentTrackCall(event, properties) {
  const { analyticsGlobals = {}, location = {} } = window;

  const eventProperties = {
    ...properties,
    userId: analyticsGlobals.userId,
    request_id: analyticsGlobals.requestId,
    app_version: analyticsGlobals.appVersion,
    experiments: varsFromServer.experimentsString,
    app_name: 'vanilla',
    path: location.pathname,
    url: location.href,
    heapUserId: properties.heapUserId || (global.GTMheapId && global.GTMheapId.userId)
  };

  if (global.analytics) {
    global.analytics.track(event, eventProperties, {
      integrations: {
        Heap: true
      }
    });
  }
}

export function triggerDataLayer(events) {
  global.analytics.ready(() => {
    window.dataLayer.push(...events);
  });
}

export function trackInteraction(properties) {
  makeSegmentTrackCall(EventNameTypes.interaction, properties);
}

export function setupScrollAnalyticsTracking({ label, selector }) {
  let didSendTrackEvent = false;

  const observer = new IntersectionObserver(entries => {
    const [entry] = entries;
    if (entry.isIntersecting && !didSendTrackEvent) {
      trackInteraction({ label });
      didSendTrackEvent = true;
    }
  });

  observer.observe(document.querySelector(selector));
}

// This log can be removed after 11/31/19
if (window.analytics) {
  window.analytics.ready(() => {
    if (window.location.pathname === '/' && window.LE) {
      window.LE.info(
        `Data Analytics Troubleshooting - after analytics.ready() called - userId is ${window.analyticsGlobals.userId}`
      );
    }
  });
}
